import {sliderOpt} from 'src/app/shared/data';

export const introSlider = {
    ...sliderOpt,
    nav: false,
    loop: false,
    responsive: {
        992: {
            nav: true
        }
    }
};


export const slides = [
    {
        button_link: '#',
        image: 'assets/images/ai/banner1.jpg',
        mobile_image: 'assets/images/ai/banner1_mobile.jpg',
        published: '1',
        show_text: '1',
        subtitle: '<h3><strong>IndiaPicture AI: Your Imagination, Our Intelligence.</strong></h3><p><br>&nbsp;</p>',
        button_title: 'Explore',
        title: '',
        text_type: 1
    }
];

export const data = {
    uuid: 'd2a8b051-5aa4-47a2-9a36-5538b4b2ca9d',
    prompt: 'create background image in light shades',
    status: 'completed',
    purchaseStatus: 'paid',
    items: [{
        uuid: '6548a031-dfe0-4780-be37-e40df2857014',
        dpItemId: 836314086,
        previewUrl: 'https://st5.depositphotos.com/secure/96421446/836314086/staff_1024.jpg?md5=uHnDTsyYlK5Jfivnk0vRfg&expires=1756551351&forcejpeg=true'
    }, {
        uuid: '85546d8f-5c4f-42e3-9b59-af59e0000709',
        dpItemId: 836314168,
        previewUrl: 'https://st5.depositphotos.com/secure/96421446/836314168/staff_1024.jpg?md5=0M7qinZKg_X43ACNdp8qCA&expires=1756551351&forcejpeg=true'
    }, {
        uuid: '9a407844-d135-4d68-965c-9ec2d7924d48',
        dpItemId: 836314072,
        previewUrl: 'https://st5.depositphotos.com/secure/96421446/836314072/staff_1024.jpg?md5=WKDtw3_H6oe7zC6S5fuX1A&expires=1756551351&forcejpeg=true'
    }, {
        uuid: 'd8686ae4-91ad-4d71-99f7-0e14830848b8',
        dpItemId: 836314112,
        previewUrl: 'https://st5.depositphotos.com/secure/96421446/836314112/staff_1024.jpg?md5=_qHSVNWc9S-LD2jBCgw_gA&expires=1756551351&forcejpeg=true'
    }]
};
